import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Network, NetworkAreaResponse } from '@app/home/features/topology/models/network.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/network';

  public getNetworks(): Observable<Array<Network>> {
    return this.http.get<Array<Network>>(`${this.baseUrl}/networks`);
  }

  public favoriteNetwork(network: Network): Observable<Network> {
    return this.http.post<Network>(`${this.baseUrl}/favorite`, network);
  }

  // public unfavoriteNetwork(network: Network): Observable<void> {
  //   return this.http.post<void>(`${this.baseUrl}/unfavorite`, network);
  // }

  public removeNetwork(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  public computeNetworkData(request): Observable<Array<NetworkAreaResponse>> {
    return this.http.post<Array<NetworkAreaResponse>>(`${this.baseUrl}/compute`, request);
  }
}
